import { render, staticRenderFns } from "./massUpdate-Add-Modal.vue?vue&type=template&id=0a0612bd&scoped=true"
import script from "./massUpdate-Add-Modal.vue?vue&type=script&lang=js"
export * from "./massUpdate-Add-Modal.vue?vue&type=script&lang=js"
import style0 from "./massUpdate-Add-Modal.vue?vue&type=style&index=0&id=0a0612bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0612bd",
  null
  
)

export default component.exports